<template>
  <div class="row poppins h-100">
    <div class="col-12 h-100">
      <div class="table-wrapper h-100 d-flex flex-column">
        <div class="filter-block">
          <div class="d-flex">
            <SearchInput :searchChange="searchChange" />
            <b-button v-if="onImport" variant="outline-primary" size="sm" class="ml-2 color-blue-light" @click="importFile">
              <ImportIcon class="mr-1" />
              {{ importTemplateText | i18n }}
            </b-button>
            <ExportTemplateDropdown
              v-if="onExport"
              :exportTemplateText="exportTemplateText"
              :selectedList="selectedList"
              :jsonExportFieldList="jsonExportFieldList"
              :onExport="onExport"
            />
          </div>
          <!-- <div class="date-range-block">
              <date-range-picker :update="dateRangeChange" v-model="filter.dateRange" />
            </div> -->
          <div v-if="isCommonAdmin" class="d-flex">
            <b-button variant="primary" size="lg" class="pl-3 pr-4 d-flex align-items-center" @click="goToNewTemplatePage">
              <BIconPlus class="mr-2" />
              {{ newTemplateText | i18n }}
            </b-button>
            <b-button
              v-if="CAN_DELETE.includes(auth.role)"
              variant="outline-danger"
              size="lg"
              class="ml-3 pl-4 pr-4 d-flex align-items-center"
              :disabled="!selectedList.length"
              @click="deleteTemplate"
            >
              <img :src="deleteIconUrl" class="mr-2" />
              {{ removeTemplateText | i18n }}
            </b-button>
          </div>
        </div>
        <Table
          :update="getPage"
          :columns="columns"
          :rows="rows"
          :filter="filter"
          :updateFilter="updateFilter"
          :loadingInstance="loadingInstance"
          :setLoadingInstance="setLoadingInstance"
          :selectedList="selectedList"
          :setSelectedList="setSelectedList"
          class="overflow-auto pr-1"
          tableName="templateListTable"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { BIconArrowRightShort, BIconPlus, BIconSearch } from 'bootstrap-vue';

import { ReportsMixin, DeleteRowMixin, NotificationMixin, AuthMixin } from '../../../../mixins';
import SearchInput from '../../common/search-input';
import Table from '../../common/table';
import { CAN_DELETE } from '../../../../../../../constants';
import DeleteIcon from '../../../../assets/icons/delete.svg';
import DetailsIcon from '../../../../assets/icons/iconsCode/details';
import CopyIcon from '../../../../assets/icons/iconsCode/copy';
import ImportIcon from '../../../../assets/icons/iconsCode/import';

import ExportTemplateDropdown from '../export-template/export-template-dropdown';

let inputInterval = null;

export default {
  title: 'Base-Templates-List',
  components: { BIconPlus, BIconSearch, Table, SearchInput, ExportTemplateDropdown, DetailsIcon, CopyIcon, ImportIcon },
  mixins: [ReportsMixin, DeleteRowMixin, NotificationMixin, AuthMixin],
  props: {
    goToNewTemplatePage: {
      type: Function,
      default: () => {},
    },
    goToEditTemplate: {
      type: Function,
      default: () => {},
    },
    goToCopyItem: {
      type: Function,
      default: () => {},
    },
    onDelete: {
      type: Function,
      default: () => {},
    },
    onGet: {
      type: Function,
      default: () => {},
    },
    onImport: {
      type: [Function, Boolean],
      default: null,
    },
    onExport: {
      type: [Function, Boolean],
      default: null,
    },
    importTemplateText: {
      type: String,
      default: 'Import Template',
    },
    exportTemplateText: {
      type: String,
      default: 'Export Template',
    },
    newTemplateText: {
      type: String,
      default: 'New Template',
    },
    removeTemplateText: {
      type: String,
      default: 'Remove Template',
    },
    jsonExportFieldList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      deleteIconUrl: DeleteIcon,
      selectedList: [],
      loadingInstance: null,
      CAN_DELETE: CAN_DELETE,
      filter: {
        page: 1,
        limit: 10,
        totalCount: 0,
        sortBy: 'updatedAt',
        sortOrder: 'desc',
        dateRange: {},
        searchQuery: '',
      },
      columns: [
        {
          field: 'check',
          key: '1',
          type: 'checkbox',
          title: '',
          width: 50,
          align: 'center',
        },
        {
          field: 'name',
          title: this.$translate('name'),
          key: '2',
          sortBy: '',
          align: 'left',
        },
        {
          field: 'description',
          title: this.$translate('description'),
          key: '3',
          sortBy: '',
          align: 'left',
        },
        {
          field: 'createdAt',
          title: this.$translate('created_date'),
          key: '4',
          sortBy: '',
        },
        {
          field: 'updatedAt',
          title: this.$translate('updated_date'),
          key: '5',
          sortBy: 'desc',
        },
        {
          field: 'actions',
          title: '',
          key: '6',
          width: 50,
          renderBodyCell: ({ row }) => {
            return (
              <div class="action-block">
                {this.isCommonAdmin && (
                  <b-button variant="link" size="sm" class="d-flex align-items-center mr-3" on-click={() => this.goToCopyItem(row.id)}>
                    <CopyIcon class="mr-1" />
                    {this.$translate('Copy')}
                  </b-button>
                )}
                <b-button variant="primary" size="sm" class="p-2 size-12" on-click={() => this.goToEditTemplate(row.id)}>
                  <DetailsIcon />
                </b-button>
              </div>
            );
          },
        },
      ],
      rows: [],
    };
  },
  methods: {
    async importFile() {
      var input = document.createElement('input');
      input.type = 'file';
      input.onchange = (e) => {
        var file = e.target.files[0];
        var reader = new FileReader();
        reader.readAsText(file, 'UTF-8');
        reader.onload = async (readerEvent) => {
          try {
            var content = readerEvent.target.result;
            const contentObj = JSON.parse(content);
            this.showNotification({ type: 'success', message: this.$translate('Importing...') });
            await this.onImport({ templates: contentObj });
            await this.getPage();
            this.showNotification({ type: 'success', message: this.$translate('success') });
          } catch (e) {
            console.log('Error import template:', e);
            this.showNotification({ type: 'error', message: this.$translate('Wrong file') });
          }
        };
      };

      input.click();
    },
    updateFilter(f) {
      this.filter = {
        ...this.filter,
        ...f,
      };
    },
    setSelectedList(list) {
      this.selectedList = list;
    },
    setLoadingInstance(loadingInstance) {
      this.loadingInstance = loadingInstance;
    },
    searchChange(e) {
      const v = e.target.value;
      this.filter.searchQuery = v;
      if (inputInterval) {
        clearTimeout(inputInterval);
      }
      inputInterval = setTimeout(() => {
        this.getPage();
      }, 500);
    },
    dateRangeChange(date) {
      this.filter.dateRange = {
        endDate: date.endDate ? moment(date.endDate).format('YYYY-MM-DD') : '',
        startDate: date.startDate ? moment(date.startDate).format('YYYY-MM-DD') : '',
      };
      this.getPage();
    },
    async deleteTemplate() {
      try {
        await this.deleteSelectedRows(
          {
            message: this.$translate('template_delete_message'),
            rowDisplayValues: this.selectedList.map((r) => r.name),
          },
          async () => {
            const ids = this.selectedList.map((r) => r.id);
            await this.onDelete({ ids });
            this.rows = this.rows.filter((i) => !ids.includes(i.id));
            this.selectedList = [];
            this.getPage();
          }
        );
      } catch (err) {
        this.showNotification({ type: 'error', message: err.message });
      }
    },
    startLoading() {
      this.loadingInstance.show();
    },
    stopLoading() {
      this.loadingInstance.close();
    },
    async getPage() {
      try {
        this.startLoading();
        const { page, limit, sortBy, sortOrder, dateRange, searchQuery } = this.filter;
        const ctx = {
          page,
          limit,
          sortBy,
          sortOrder,
          searchQuery,
        };
        if (dateRange && dateRange.startDate && dateRange.endDate) {
          ctx.startDate = dateRange.startDate;
          ctx.endDate = dateRange.endDate;
        }
        const response = await this.onGet(ctx);
        response.data = response.data.map((item) => ({
          ...item,
          createdAt: moment(item.createdAt).format('DD.MM.YY HH:mm'),
          updatedAt: moment(item.updatedAt).format('DD.MM.YY HH:mm'),
        }));
        this.filter.totalCount = response.totalCount;
        this.stopLoading();
        this.rows = response.data;
      } catch (err) {
        this.showNotification({ type: 'error', message: err.message });
      }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .ve-table-body {
  ::v-deep th {
    color: rgb(112, 112, 112) !important;
    background-color: rgb(239, 239, 239) !important;
    border: none !important;
    min-height: 50px;
  }
  ::v-deep td {
    color: rgb(112, 112, 112) !important;
    cursor: pointer;
  }
}

::v-deep .ve-table-cell-selection {
  border: none !important;
}

::v-deep .ve-table-sort {
  top: -4.5px;
}

::v-deep .details-action {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background: rgb(34, 129, 254);
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 28px;
  margin: auto;
}

.statuses-block {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}

.date-range-block {
  min-width: 350px;
  text-align: center;
  margin-left: 30px;
  display: flex;
  align-items: center;
}

::v-deep .ve-select-selected-span {
  font-weight: 400;
}

.pagination-block {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}

::v-deep .copy-button {
  background: rgb(237, 248, 254);
  border: 2px solid rgb(175, 216, 255);
  border-radius: 4px;
  padding: 2px 13px;
  margin: 0px 5px;
  color: rgb(49, 141, 255);
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  margin-right: 20px;
  cursor: pointer;
}

.action-block {
  display: flex;
}

::v-deep .btn-lg {
  font-size: 16px;
  line-height: 24px;
}

::v-deep .size-12 {
  font-size: 12px;
  line-height: 12px;
}

.color-blue-light {
  background: rgba(34, 96, 255, 0.1);
  color: #2260ff;
}
</style>
